import store from 'public/store'
import router from '../router'
import bus from 'public/utils/bus'
import MENUSTYLE from './menu-style'
import { QtReportOpenModuleByLeftMenu } from '@/layout/utils/report-qt.js'

// 需要从菜单树中隐藏的菜单ID列表： 财务成本管理详情
const HideMenus = ['152995231408803407']

const GROUP_NUM = 5 // 分组数

function filterTree (tree) {
  try {
    if (!Array.isArray(tree)) {
      return tree
    }
    return tree.filter(function(item) {
      return !HideMenus.includes(item.id)
    })
  } catch (e) {
    console.error('【layout-menu:filterTree】', e)
    return tree
  }
}


class KYEMenu extends HTMLElement {
  constructor () {
    super()
    this.attachShadow({ mode: 'open' })
    this.bindActiveMenu = this.delayActiveMenu.bind(this)
    this.bindCollapseMenu = this.collapseMenu.bind(this)
    this.bindRemindMenu = this.remindMenu.bind(this)
    this.bindOpenMenu = this.openMenu.bind(this)
    this.bindSetTheme = this.setTheme.bind(this)
    this.isClickNode = false
    bus.$on('TAB_CLICK', this.bindActiveMenu)
    bus.$on('SWITCH_MENU', this.bindCollapseMenu)
    bus.$on('SET_MENUS_REMIND', this.bindRemindMenu)
    bus.$on('GLOBAL_MENU_OPEN', this.bindOpenMenu)
    bus.$on('SET_THEME', this.bindSetTheme)
    bus.$on('APP_LOADED', this.render.bind(this))
  }

  disconnectedCallback () {
    bus.$off('TAB_CLICK', this.bindActiveMenu)
    bus.$off('SWITCH_MENU', this.bindCollapseMenu)
    bus.$off('SET_MENUS_REMIND', this.bindRemindMenu)
    bus.$off('GLOBAL_MENU_OPEN', this.bindOpenMenu)
    bus.$off('SET_THEME', this.bindSetTheme)
  }

  get sync () {
    return this.getAttribute('sync') === 'true'
  }

  setTheme (obj, type) {
    if (!type || type === 'menu') {
      // 暂存参数，延迟到菜单 render 后执行
      if (!this.rootDom) {
        this.setThemeArgs = [obj, type]
        return
      }
      // let src = this.svgDoms[0].src
      if (obj.menu === 'dark') {
        this.rootDom.classList.add('level1_dark')
        // if (!src.endsWith('_dark.svg')) {
        //   this.svgDoms.forEach(v => v.src = v.src.replace('.svg', '_dark.svg'))
        // }
      } else {
        this.rootDom.classList.remove('level1_dark')
        // if (src.endsWith('_dark.svg')) {
        //   this.svgDoms.forEach(v => v.src = v.src.replace('_dark', ''))
        // }
      }
    }
  }

  collapseMenu (width, isCollapse) {
    if (isCollapse) {
      this.min()
    } else {
      this.max()
    }
  }

  remindMenu () {
    const menus = store.state.remindMenus || {}
    const shows = []
    const removes = []
    Object.keys(menus).forEach(v => {
      if (menus[v]) {
        shows.push(v)
      } else {
        removes.push(v)
      }
    })
    removes.forEach(this.removeMark.bind(this))
    shows.forEach(this.showMark.bind(this))
  }

  openMenu ({ tag }) {
    if (this.activeTag && tag !== this.activeTag) {
      this.delayActiveMenu(window.location.hash.substr(1), tag)
    }
  }

  delayActiveMenu (path, tag, keep) {
    clearTimeout(this._activeMenuTimer)
    this._activeMenuTimer = setTimeout(_ => {
      this.activeMenu(path, tag, keep)
      this._activeMenuTimer = null
    }, 300)
  }

  scrollActiveMenu (tag) {
    // if (!tag || !tag.scrollIntoView) return
    // tag.scrollIntoView({ block: 'center', behavior: 'smooth' })
  }

  activeMenu (path, tag, keep) {
    if (!this.sync || !path) return
    if (keep) {
      this.menuDoms.forEach(this.removeActive)
      return
    }
    tag = tag || router.resolve(path).route.meta.tag
    this.activeTag = tag
    tag = tag && store.getters.menus[tag]
    if (!tag) return
    let { id, parentId, title, $ptitle } = tag
    let inputTop = this.shadowRoot.querySelector(`#${$ptitle}`)
    let activeDom = null
    if (parentId) {
      // 3级菜单
      let input = this.shadowRoot.querySelector(`#id${parentId}`)
      if (!input || !inputTop) return
      inputTop.checked = true
      input.checked = true
      let clickEvent = new CustomEvent('autoClick', { detail: { input, inputTop } })
      this.rootDom.dispatchEvent(clickEvent)
      this.menuDoms.forEach(this.removeActive)
      activeDom = this.shadowRoot.querySelector(`#id${id}`)
      activeDom.classList.add('active')
      !this.isClickNode && this.scrollActiveMenu(activeDom)
      this.addActiveLink($ptitle)
      let parentLabel = this.shadowRoot.querySelector(`#id${parentId}+a`) // 二级 a 标签
      if (parentLabel) {
        parentLabel.classList.add('activelink') // 二级父菜单加粗
      }
    } else if (inputTop) {
      this.menuDoms.forEach(this.removeActive)
      let a = this.shadowRoot.querySelector(`#id${id}+a`)
      if (a) {
        // 2级菜单
        inputTop.checked = true
        let clickEvent = new CustomEvent('autoClick', { detail: { inputTop } })
        this.rootDom.dispatchEvent(clickEvent)
        a.classList.add('active')
        !this.isClickNode && this.scrollActiveMenu(a)
        this.addActiveLink($ptitle)
      } else {
        // 1级菜单
        activeDom = this.shadowRoot.querySelector(`#${title}+a`)
        activeDom.classList.add('active')
        this.scrollActiveMenu(activeDom)
        this.addActiveLink(title)
      }
    }
    // TAB_CLICK 会被 Router 路由导航回调重新触发
    setTimeout(() => {
      this.isClickNode = false
    }, 500)
  }

  // 通过菜单tag跳转路由，并同步更新标签页状态
  setRoute (tag) {
    if (!tag) return
    let view = store.state.tagsView.visitedViews.find(v => v.tag === tag)
    let path = view && view.path !== tag ? view.path : tag
    const route = router.resolve(path).route
    route.meta.layout = true
    bus.$emit('GLOBAL_USE_OPEN_MODULE', route.meta.tag || tag)
    window.location.hash = '#' + path
    // 从框架布局进入，添加入口标记
    bus.$emit('TAB_CLICK', path, tag)
  }

  removeActive (dom) {
    if (dom.classList.contains('active')) {
      dom.classList.remove('active')
    }
    if (dom.classList.contains('activelink')) {
      dom.classList.remove('activelink')
    }
  }

  addActiveLink (title) {
    // 一级菜单反白处理
    let temp = this.shadowRoot.querySelector('.activelink')
    if (temp) {
      temp.classList.remove('activelink')
    }
    this.shadowRoot.querySelector(`#${title}+a`).classList.add('activelink')
  }

  // 折叠侧边栏：添加min-size类并初始化hover交互
  min () {
    // 清除待执行的 activeMenu 定时器，防止在折叠态下错误勾选 checkbox
    clearTimeout(this._activeMenuTimer)
    // 折叠前先清除所有checkbox的checked状态，避免CSS规则冲突
    this.level1InputDoms && this.level1InputDoms.forEach(input => { input.checked = false })
    this.level2InputDoms && this.level2InputDoms.forEach(input => { input.checked = false })
    this.rootDom.classList.add('min-size')
    this.initCollapseHover()
  }

  // 展开侧边栏：移除min-size类、销毁hover交互、重新激活菜单高亮
  max () {
    // 清除待执行的 activeMenu 定时器，防止展开过程中触发旧状态逻辑
    clearTimeout(this._activeMenuTimer)
    this.rootDom.classList.remove('min-size')
    this.destroyCollapseHover()
    // 展开后重新激活当前路由对应的菜单高亮
    this.delayActiveMenu(window.location.hash.substr(1))
  }

  // 折叠模式入口：初始化状态、绑定事件，使菜单在折叠态下通过hover展开子面板
  initCollapseHover () {
    if (this.collapseInited) return
    this.initCollapseState()
    this.bindCheckboxPrevention()
    this.bindLevel1ItemsHover()
  }

  initCollapseState () {
    this.collapseInited = true
    this.collapseHandlers = []
    this.activeLevel3Panel = null
    this.hideLevel2Timer = null
    this.hideLevel3Timer = null
    this.panelLocked = false
    this.level2LeaveIntent = false
    this.level3LeaveIntent = false
  }

  // 折叠模式下阻止二级checkbox的点击切换，改用hover控制展开收起
  bindCheckboxPrevention () {
    const preventCheckbox = (e) => {
      if (!this.rootDom.classList.contains('min-size')) return
      const target = e.target
      if (target.nodeName === 'LABEL' && target.hasAttribute('for')) {
        const inputId = target.getAttribute('for')
        const input = this.shadowRoot.getElementById(inputId)
        if (input && input.classList.contains('level2input')) {
          e.preventDefault()
        }
      }
    }
    this.rootDom.addEventListener('click', preventCheckbox, true)
    this.collapseHandlers.push({ el: this.rootDom, type: 'click', fn: preventCheckbox, capture: true })
  }

  bindLevel1ItemsHover () {
    const level1Items = this.rootDom.querySelectorAll(':scope > li')
    level1Items.forEach(li => {
      const level2Ul = li.querySelector(':scope > ul.level2')
      if (!level2Ul) {
        this.bindLeafLevel1Hover(li)
      } else {
        this.bindParentLevel1Hover(li, level2Ul)
      }
    })
  }

  // 无子菜单的一级项：hover时关闭其他已展开的面板
  bindLeafLevel1Hover (li) {
    const hideOtherPanels = () => {
      if (!this.rootDom.classList.contains('min-size')) return
      clearTimeout(this.hideLevel2Timer)
      this.closeAllCollapsedPanels()
    }
    li.addEventListener('mouseenter', hideOtherPanels)
    this.collapseHandlers.push({ el: li, type: 'mouseenter', fn: hideOtherPanels })
  }

  closeAllCollapsedPanels () {
    this.rootDom.querySelectorAll(':scope > li > ul.level2.collapsed-panel').forEach(ul => {
      ul.querySelectorAll(':scope > li > input.level2input').forEach(input => {
        input.checked = false
      })
      ul.classList.remove('collapsed-panel')
      ul.style.top = ''
      this.hideAllLevel3Panels(ul)
      this.removeLevel2Arrow(ul)
    })
  }

  bindParentLevel1Hover (li, level2Ul) {
    const showLevel2 = () => {
      this.showLevel2Panel(li, level2Ul)
    }
    const hideLevel2 = () => {
      this.hideLevel2Panel(li, level2Ul)
    }
    li.addEventListener('mouseenter', showLevel2)
    li.addEventListener('mouseleave', hideLevel2)
    this.collapseHandlers.push(
      { el: li, type: 'mouseenter', fn: showLevel2 },
      { el: li, type: 'mouseleave', fn: hideLevel2 }
    )
    this.bindLevel2PanelHover(level2Ul, hideLevel2)
  }

  // 清除一级和二级checkbox的checked状态，防止CSS规则 input:checked ~ ul 导致面板残留显示
  clearLevelInputs (li, level2Ul) {
    const level1Input = li.querySelector(':scope > input.level1input')
    if (level1Input) level1Input.checked = false
    level2Ul.querySelectorAll(':scope > li > input.level2input').forEach(input => {
      input.checked = false
    })
  }

  showLevel2Panel (li, level2Ul) {
    if (!this.rootDom.classList.contains('min-size')) return
    this.clearLevelInputs(li, level2Ul)
    clearTimeout(this.hideLevel2Timer)
    this.closeOtherLevel2Panels(level2Ul)
    level2Ul.classList.add('collapsed-panel')
    this.positionLevel2Panel(li, level2Ul)
    this.showLevel2Arrow(level2Ul, li.getBoundingClientRect())
    this.initLevel3Hover(level2Ul)
  }

  closeOtherLevel2Panels (currentLevel2Ul) {
    this.rootDom.querySelectorAll(':scope > li > ul.level2.collapsed-panel').forEach(ul => {
      if (ul !== currentLevel2Ul) {
        ul.classList.remove('collapsed-panel')
        ul.style.top = ''
        this.hideAllLevel3Panels(ul)
        this.removeLevel2Arrow(ul)
      }
    })
  }

  getSideViewHeight () {
    // 与 style 定义保持一致
    return window.innerHeight * 0.75
  }

  getScrollBarScrollTop () {
    return document.querySelector('.el-aside.kye-aside-panel .el-scrollbar__wrap.kye-sidebar-menu').scrollTop
  }

  getSearchHeight () {
    return document.querySelector('.kye-sidebar-search.is-collapse').offsetHeight
  }

  // 二级面板碰撞检测：当面板超出视口底部时向上偏移，保证面板完全可见
  positionLevel2Panel (li, level2Ul) {
    const bodyTop = this.rootDom ? this.rootDom.getBoundingClientRect().top : 50
    const liRect = li.getBoundingClientRect()
    const panelHeight = level2Ul.scrollHeight
    const viewportH = this.getSideViewHeight()
    let top = liRect.top - bodyTop
    if (top + panelHeight > viewportH - 10) {
      top = Math.max(10, viewportH - panelHeight - 10)
    }
    if (top + panelHeight < liRect.bottom - bodyTop) {
      top = liRect.bottom - bodyTop - panelHeight
    }
    const scrollBarScrollTop = this.getScrollBarScrollTop()
    const searchHeight = this.getSearchHeight()
    let curTop = top - scrollBarScrollTop + searchHeight
    if (curTop < 0) {
      curTop = 0
    }
    level2Ul.style.top = curTop + 'px'
  }

  // 隐藏二级面板：若面板被锁定（三级面板显示中）则仅记录离开意图，否则延迟200ms隐藏
  hideLevel2Panel (li, level2Ul) {
    if (!this.rootDom.classList.contains('min-size')) return
    if (this.panelLocked) {
      this.level2LeaveIntent = true
      return
    }
    this.hideLevel2Timer = setTimeout(() => {
      this.clearLevelInputs(li, level2Ul)
      level2Ul.classList.remove('collapsed-panel')
      level2Ul.style.top = ''
      this.hideAllLevel3Panels(level2Ul)
      this.removeLevel2Arrow(level2Ul)
    }, 200)
  }

  bindLevel2PanelHover (level2Ul, hideLevel2) {
    level2Ul.addEventListener('mouseenter', () => {
      if (!this.rootDom.classList.contains('min-size')) return
      clearTimeout(this.hideLevel2Timer)
    })
    level2Ul.addEventListener('mouseleave', () => {
      if (!this.rootDom.classList.contains('min-size')) return
      if (this.panelLocked && this.activeLevel3Panel) {
        // 有三级面板在显示时，启动延迟检测
        // 若鼠标正在移向三级面板，三级面板的 mouseenter 会 clearTimeout 取消本次隐藏
        this.level2LeaveIntent = true
        clearTimeout(this.hideLevel2Timer)
        this.hideLevel2Timer = setTimeout(() => {
          this.tryUnlockAndHide(level2Ul, this.activeLevel3Panel)
        }, 200)
      } else {
        hideLevel2()
      }
    })
  }

  initLevel3Hover (level2Ul) {
    if (level2Ul.menuLevel3Inited) return
    level2Ul.menuLevel3Inited = true
    const items = level2Ul.querySelectorAll(':scope > li')
    items.forEach(li => {
      const level3Ul = li.querySelector(':scope > ul.level3')
      if (!level3Ul) {
        this.bindLeafLevel2Hover(li, level2Ul)
      } else {
        this.bindParentLevel2Hover(li, level2Ul, level3Ul)
      }
    })
  }

  bindLeafLevel2Hover (li, level2Ul) {
    const hideOtherLevel3 = () => {
      if (!this.rootDom.classList.contains('min-size')) return
      clearTimeout(this.hideLevel3Timer)
      this.hideAllLevel3Panels(level2Ul)
      this.panelLocked = false
      this.level2LeaveIntent = false
      this.level3LeaveIntent = false
    }
    li.addEventListener('mouseenter', hideOtherLevel3)
  }

  bindParentLevel2Hover (li, level2Ul, level3Ul) {
    const showLevel3 = () => {
      this.showLevel3Panel(li, level2Ul, level3Ul)
    }
    const hideLevel3 = () => {
      this.hideLevel3Panel(level3Ul)
    }
    li.addEventListener('mouseenter', showLevel3)
    li.addEventListener('mouseleave', hideLevel3)
    this.bindLevel3PanelHover(level2Ul, level3Ul, hideLevel3)
  }

  // 三级面板显示时锁定二级面板，防止鼠标在三级面板上移动时二级面板意外消失
  showLevel3Panel (li, level2Ul, level3Ul) {
    if (!this.rootDom.classList.contains('min-size')) return
    clearTimeout(this.hideLevel3Timer)
    clearTimeout(this.hideLevel2Timer)
    this.hideAllLevel3Panels(level2Ul)
    level3Ul.classList.add('collapsed-panel')
    this.activeLevel3Panel = level3Ul
    this.panelLocked = true
    this.level2LeaveIntent = false
    this.level3LeaveIntent = false
    this.positionLevel3Panel(li, level2Ul, level3Ul)
  }

  // 三级面板碰撞检测：定位到二级面板右侧，超出视口底部时向上偏移
  positionLevel3Panel (li, level2Ul, level3Ul) {
    const bodyTop = this.rootDom ? this.rootDom.getBoundingClientRect().top : 50
    const liRect = li.getBoundingClientRect()
    const level2Rect = level2Ul.getBoundingClientRect()
    const panelHeight = level3Ul.scrollHeight
    const viewportH = this.getSideViewHeight()
    let top = liRect.top - bodyTop
    if (top + panelHeight > viewportH - 10) {
      top = Math.max(10, viewportH - panelHeight - 10)
    }
    if (top + panelHeight < liRect.bottom - bodyTop) {
      top = liRect.bottom - bodyTop - panelHeight
    }
    const scrollBarScrollTop = this.getScrollBarScrollTop()
    const searchHeight = this.getSearchHeight()
    let curTop = top - scrollBarScrollTop + searchHeight - 4
    if (curTop < 0) {
      curTop = 0
    }
    level3Ul.style.top = curTop + 'px'
    level3Ul.style.left = (level2Rect.right + 4) + 'px'
  }

  // 隐藏三级面板：若面板被锁定则仅记录离开意图，否则延迟200ms隐藏
  hideLevel3Panel (level3Ul) {
    if (!this.rootDom.classList.contains('min-size')) return
    if (this.panelLocked) {
      this.level3LeaveIntent = true
      return
    }
    this.hideLevel3Timer = setTimeout(() => {
      this.removeLevel3PanelStyle(level3Ul)
    }, 200)
  }

  removeLevel3PanelStyle (level3Ul) {
    level3Ul.classList.remove('collapsed-panel')
    level3Ul.style.top = ''
    level3Ul.style.left = ''
    if (this.activeLevel3Panel === level3Ul) {
      this.activeLevel3Panel = null
    }
  }

  bindLevel3PanelHover (level2Ul, level3Ul, hideLevel3) {
    level3Ul.addEventListener('mouseenter', () => {
      if (!this.rootDom.classList.contains('min-size')) return
      clearTimeout(this.hideLevel3Timer)
      clearTimeout(this.hideLevel2Timer)
      level3Ul.classList.add('collapsed-panel')
      this.level3LeaveIntent = false
      this.level2LeaveIntent = false
    })
    level3Ul.addEventListener('mouseleave', () => {
      if (!this.rootDom.classList.contains('min-size')) return
      if (this.panelLocked) {
        this.level3LeaveIntent = true
        this.tryUnlockAndHide(level2Ul, level3Ul)
      } else {
        hideLevel3()
      }
    })
  }

  // 面板锁定解锁机制：鼠标离开面板区域时，检测鼠标是否仍在二级/三级面板内，
  // 只有真正离开所有面板才解锁并执行隐藏，避免鼠标在面板间移动时意外消失
  tryUnlockAndHide (level2Ul, level3Ul) {
    if (!this.rootDom.classList.contains('min-size')) return
    requestAnimationFrame(() => {
      if (this.isMouseInPanels(level2Ul, level3Ul)) {
        this.level2LeaveIntent = false
        this.level3LeaveIntent = false
        return
      }
      this.panelLocked = false
      if (this.level3LeaveIntent) {
        this.level3LeaveIntent = false
        this.removeLevel3PanelStyle(level3Ul)
      }
      if (this.level2LeaveIntent) {
        this.level2LeaveIntent = false
        this.scheduleHideLevel2(level2Ul)
      }
    })
  }

  // 用 :hover 伪类判断鼠标是否在面板内：浏览器基于真实指针位置维护，
  isMouseInPanels (level2Ul, level3Ul) {
    return level2Ul.matches(':hover') || !!(level3Ul && level3Ul.matches(':hover'))
  }

  scheduleHideLevel2 (level2Ul) {
    this.hideLevel2Timer = setTimeout(() => {
      level2Ul.classList.remove('collapsed-panel')
      level2Ul.style.top = ''
      this.hideAllLevel3Panels(level2Ul)
      this.removeLevel2Arrow(level2Ul)
    }, 100)
  }

  // 显示二级面板的左侧三角箭头，始终居中指向一级菜单项
  showLevel2Arrow (level2Ul, liRect) {
    if (!level2Ul.menuArrowEl) {
      level2Ul.menuArrowEl = document.createElement('div')
      level2Ul.menuArrowEl.classList.add('level2-arrow')
      this.rootDom.appendChild(level2Ul.menuArrowEl)
    }
    const bodyTop = this.rootDom ? this.rootDom.getBoundingClientRect().top : 50
    const firstLevelCenter = liRect.top + liRect.height / 2 - bodyTop
    const scrollBarScrollTop = this.getScrollBarScrollTop()
    const searchHeight = this.getSearchHeight()
    level2Ul.menuArrowEl.style.top = firstLevelCenter - scrollBarScrollTop + searchHeight + 'px'
  }

  // 移除二级面板的三角箭头
  removeLevel2Arrow (level2Ul) {
    if (level2Ul.menuArrowEl) {
      level2Ul.menuArrowEl.remove()
      level2Ul.menuArrowEl = null
    }
  }

  // 隐藏二级面板内所有三级面板
  hideAllLevel3Panels (level2Ul) {
    const panels = level2Ul.querySelectorAll('.level3.collapsed-panel')
    panels.forEach(p => {
      p.classList.remove('collapsed-panel')
      p.style.top = ''
      p.style.left = ''
    })
    this.activeLevel3Panel = null
  }

  // 折叠模式：销毁hover事件
  destroyCollapseHover () {
    if (!this.collapseInited) return
    this.collapseInited = false
    clearTimeout(this.hideLevel2Timer)
    clearTimeout(this.hideLevel3Timer)
    if (this.collapseHandlers) {
      this.collapseHandlers.forEach(({ el, type, fn, capture }) => {
        el.removeEventListener(type, fn, capture || false)
      })
      this.collapseHandlers = []
    }
    // 清除所有面板状态
    const panels = this.rootDom.querySelectorAll('.collapsed-panel')
    panels.forEach(p => {
      p.classList.remove('collapsed-panel')
      p.style.top = ''
      p.style.left = ''
    })
    // 清除所有二级面板的三角箭头
    this.rootDom.querySelectorAll(':scope > li > ul.level2').forEach(ul => {
      this.removeLevel2Arrow(ul)
    })
    this.activeLevel3Panel = null
    this.panelLocked = false
    this.level2LeaveIntent = false
    this.level3LeaveIntent = false
  }

  removeMark (path) {
    let { id, parentId, $ptitle } = store.getters.menus[path] || {}
    if (parentId) {
      let dom = this.shadowRoot.querySelector(`#id${id}`)
      dom && dom.classList.remove('mark')
      dom = this.shadowRoot.querySelector(`#label${parentId}`)
      dom && dom.classList.remove('mark')
    } else {
      let dom = this.shadowRoot.querySelector(`#label${id}`)
      dom && dom.classList.remove('mark')
    }
    let dom = this.shadowRoot.querySelector(`#label${$ptitle}`)
    dom && dom.classList.remove('mark')
  }

  showMark (path) {
    let { id, parentId, $ptitle } = store.getters.menus[path] || {}
    if (parentId) {
      let dom = this.shadowRoot.querySelector(`#id${id}`)
      dom && dom.classList.add('mark')
      dom = this.shadowRoot.querySelector(`#label${parentId}`)
      dom && dom.classList.add('mark')
    } else {
      let dom = this.shadowRoot.querySelector(`#label${id}`)
      dom && dom.classList.add('mark')
    }
    let dom = this.shadowRoot.querySelector(`#label${$ptitle}`)
    dom && dom.classList.add('mark')
  }

  // 菜单点击事件代理：处理checkbox手风琴效果、路由跳转、标签页点击
  initEvent () {
    if (this.getAttribute('unique-opened') !== 'true') return
    let self = this
    this.rootDom.addEventListener('click', function (e) {
      let type = e.target.nodeName
      if (type === 'INPUT') {
        self.handelClick(e.target)
      } else if (type === 'A') {
        e.preventDefault()
        self.isClickNode = true
        self.setRoute(e.target.hash.substr(1))
        QtReportOpenModuleByLeftMenu(e.target.hash.substr(1))
      } else if (type === 'LABEL') {
        let path = e.target.getAttribute('path')
        if (path) {
          self.isClickNode = true
          self.setRoute(path)
          QtReportOpenModuleByLeftMenu(path)
        }
      }
    })

    this.rootDom.addEventListener('autoClick', function (e) {
      let { input, inputTop } = e.detail
      if (input) {
        self.handelClick(input)
      }
      if (inputTop) {
        self.handelClick(inputTop)
      }
    })
  }

  // 手风琴模式：同一级只允许展开一个菜单项
  handelClick (target) {
    if (target.name === 'level1') {
      this.level1InputDoms.forEach(input => {
        if (input !== target) input.checked = false
      })
    } else {
      this.level2InputDoms.forEach(input => {
        if (input !== target) input.checked = false
      })
    }
  }
  // 当前菜单icon
  getMenuIconUrl (menu, isActive) {
    const { menuCode, subSystem } = menu
    let str = subSystem.toLowerCase().replace(/,/g, '')
    const iconClass = isActive ? 'light' : 'gray'
    // 首页
    if (menuCode === '/') {
      str = 'home'
    }
    return `layout layout-module-${str}-${iconClass}`
  }
  // 系统分组
  isGroupEndIndex(index, arrLength) {
    // 必须是有效正整数、下标在数组范围内
    if (!Number.isInteger(index) || index < 1 || index >= arrLength) {
        return false
    }
    // 是GROUP_NUM的倍数（分组结束下标），不是数组最后一个下标
    return index % GROUP_NUM === 0 && index !== arrLength - 1
  }
  setSplitGroupLine (index, arrLength) {
    // 每6个菜单项添加分割线, 返回分割线HTML
    const isGroupLine = this.isGroupEndIndex(index, arrLength)
    if (isGroupLine) {
      return '<li class="group-line"></li>'
    }
    return ''
  }

  renderLevel2 (subTree, menuTitle) {
    return '<ul style="display:none" class="level2 kye-scrollbar ">' +
        '<li class="level2-menu-title">' + menuTitle + '</li>' +
        subTree.map(menu => `
              <li>
                <input class="level2input" type="checkbox" name="level2" id="id${menu.id}" style="display: none" />
                <a class="${menu.children ? 'tri-down' : 'menu'}" href="#${menu.children ? '' : menu.menuCode}">
                  <label id="label${menu.id}" ${menu.children ? `for="id${menu.id}"` : `path="${menu.menuCode}"`}>${menu.label}</label>
                </a>
                ${menu.children ? this.renderLevel3(menu.children) : ''}
              </li>
        `).join('') + '</ul>'
  }

  renderLevel3 (originSubTree) {
    const subTree = filterTree(originSubTree)
    return '<ul style="display:none" class="level3 kye-scrollbar">' + subTree.map(menu => `
              <li>
                <a class="menu" id="id${menu.id}" href="#${menu.menuCode}" title="${menu.label || ''}">${menu.label}</a>
              </li>
        `).join('') + '</ul>'
  }

  initMin () {
    // 根据外部折叠状态重置展开折叠效果
    const sidebarSearchDom = document.querySelector('i.kye-sidebar-search.layout.is-collapse')
    const isCollapsed = sidebarSearchDom && sidebarSearchDom.style.display !== 'none'
    if (isCollapsed) {
      this.collapseInited = false
      this.min()
    }
  }

  // 渲染菜单DOM，构建三级菜单结构并初始化交互
  render () {
    let menuTree = store.getters.menus.menuTree
    this.shadowRoot.innerHTML = `
      <link rel="stylesheet" href="//iconfont.kye-erp.com/t/c/font_1140206_mu7ssi4iyvm.css">
      <style>${MENUSTYLE}</style>
      <ul class="level1">
        ${menuTree.map((menu, mIdx) => `
          <li>
            <input class="level1input" type="checkbox" name="level1" id="${menu.label}" style="display: none" />
            <a
              class="${menu.children ? `tri-down` : 'menu'}"
              href="#${menu.menuCode || ''}"
              ${menu.tips ? `title="${menu.tips}"` : ''}>
              <label id="label${menu.label}" class="root-menu" ${menu.children ? `for="${menu.label}"` : `path="${menu.menuCode}"`}>
                <i class="${this.getMenuIconUrl(menu)}"></i>
                <i class="${this.getMenuIconUrl(menu, true)}"  style="display: none"></i>
                <span>${menu.label}</span>
              </label>
            </a>
            ${menu.children ? this.renderLevel2(menu.children, menu.label) : ''}
          </li>
          ${this.setSplitGroupLine(mIdx, menuTree.length)}
      `).join('')}
      </ul>
    `
    this.rootDom = this.shadowRoot.querySelector('.level1')
    this.menuDoms = [...this.shadowRoot.querySelectorAll('.level1 a.menu, .level1 a.tri-down')]
    this.level2InputDoms = [...this.shadowRoot.querySelectorAll('.level2 .level2input')]
    this.level1InputDoms = [...this.shadowRoot.querySelectorAll('.level1 .level1input')]
    // this.svgDoms = [...this.shadowRoot.querySelectorAll('img')]
    this.initEvent()
    this.setRoute(window.location.hash.substr(1))
    if (this.setThemeArgs) {
      this.setTheme(...this.setThemeArgs)
      // this.setThemeArgs = null
    }
    this.initMin()
  }
}

window.customElements.define('kye-menu', KYEMenu)



// WEBPACK FOOTER //
// ./src/layout/layout/menu.js